import { IpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { shouldShowLeavingDialog } from '../helpers/shouldShowLeavingDialog';

export const continueFromLeavingDialog: GraphCommandFactory =
  (cmdContext) => () => {
    const {
      leavingDialog: { continueCallback },
    } = cmdContext.getState();

    cmdContext.updateState((draft) => {
      draft.leavingDialog.open = false;
      draft.leavingDialog.continueCallback = null;
    });

    if (shouldShowLeavingDialog(cmdContext.getState())) {
      throw new IpfError(
        'INVALID_STATE',
        'Cannot continue from leaving dialog while state still indicates it should be shown',
      );
    }
    if (continueCallback) {
      continueCallback();
    }
  };
